import { BookOpen } from 'lucide-react';

import type { BookConfig } from '@/config';
import { resolveRoomAsset } from '@/utils/room-data';

const statusLabels: Record<number, string> = {
  1: '想读',
  2: '读过',
  3: '在读',
  4: '搁置',
  5: '放弃',
};

export function BookDetailCard({ book }: { book: BookConfig }) {
  const cover = resolveRoomAsset(book.cover);
  const status = book.status === null ? null : (statusLabels[book.status] ?? null);
  return (
    <article className="book-detail-card">
      {cover === null ? (
        <div className="book-detail-card-placeholder" aria-hidden="true">
          <BookOpen size={42} />
        </div>
      ) : (
        <img src={cover} alt={`${book.title} 封面`} />
      )}
      <div className="book-detail-card-content">
        <h2>{book.title}</h2>
        {book.description.length === 0 ? null : <p>{book.description}</p>}
        <dl className="book-detail-meta">
          {status === null ? null : (
            <div>
              <dt>状态</dt>
              <dd>{status}</dd>
            </div>
          )}
          {book.score === null ? null : (
            <div>
              <dt>评分</dt>
              <dd>{book.score}/10</dd>
            </div>
          )}
        </dl>
        {book.tags.length === 0 ? null : (
          <div className="tag-list" aria-label="书籍标签">
            {book.tags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}
